import { useEffect, useState, useRef } from "react";

import styles from "./Face2.module.scss";

export default function Face2() {
  const cardRef = useRef<HTMLDivElement>(null);

  const [fontSize, setFontSize] = useState<number | undefined>(undefined);
  const [fontSizeBig, setFontSizeBig] = useState<number | undefined>(undefined);
  const [letterSpacing, setLetterSpacing] = useState<number | undefined>(
    undefined
  );
  const [lineHeight, setLineHeight] = useState<number | undefined>(undefined);
  const [marginRight, setMarginRight] = useState<number | undefined>(undefined);

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      if (cardRef.current) {
        setFontSize(Math.floor(0.029 * cardRef.current.clientWidth));
        setFontSizeBig(Math.floor(0.045 * cardRef.current.clientWidth));
        setLetterSpacing(0.003 * cardRef.current.clientWidth);
        setLineHeight(0.05 * cardRef.current.clientWidth);
        setMarginRight(0.05 * cardRef.current.clientWidth);
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return (
    <div ref={cardRef} className={styles.card}>
      <div
        style={{
          fontSize: `${fontSize}px`,
          letterSpacing: `${letterSpacing}px`,
          lineHeight: `${lineHeight}px`,
          marginRight: `${marginRight}px`,
        }}
      >
        <p
          style={{
            fontSize: `${fontSizeBig}px`,
          }}
        >
          GARBAGE CANDY, CIGARETTE COFFEE
        </p>
        <p>Tell me all your secrets</p>
        <p>i can be your puppy.</p>
        <p
          style={{
            fontSize: `${fontSizeBig}px`,
          }}
        >
          GARBAGE CANDY, CIGARETTE COFFEE
        </p>
        <p>You invite me out</p>
        <p>and never come to meet me.</p>
        <p
          style={{
            fontSize: `${fontSizeBig}px`,
          }}
        >
          GARBAGE CANDY, CIGARETTE COFFEE
        </p>
        <p>Double the infatuated</p>
        <p>in the end you loved me.</p>
        <p
          style={{
            fontSize: `${fontSizeBig}px`,
          }}
        >
          GARBAGE CANDY, CIGARETTE COFFEE
        </p>
        <p>Liar, bitch, ambitious prick,</p>
        <p>Coward, gnome, catastrophe.</p>
      </div>
    </div>
  );
}
